export const runtimeRegex = /^([0-9]{2,4}):([0-5]\d):([0-5]\d)$/;

export const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export function parseBool(value) {
    const lcValue = value ? value.toLowerCase() : false;
    const falseValues = [false, 'false', 'f', 'no', 'n'];
    const trueValues = [true, 'true', 't', 'yes', 'y'];

    if (!lcValue || falseValues.includes(lcValue)) return false;
    return trueValues.includes(lcValue);
}

export const sorts = {
    asc(a, b) {
        let at = typeof a === 'string' ? a.toLowerCase() : a;
        let bt = typeof b === 'string' ? b.toLowerCase() : b;
        if (at < bt) {
            return -1;
        } else if (at > bt) {
            return 1;
        } else {
            return 0;
        }
    },
    desc(a, b) {
        let at = typeof a === 'string' ? a.toLowerCase() : a;
        let bt = typeof b === 'string' ? b.toLowerCase() : b;
        if (at > bt) {
            return -1;
        } else if (at < bt) {
            return 1;
        } else {
            return 0;
        }
    }
};

export const deepCompare = (newState, oldState, cumm = true) => {
    // flattens the object or array so that we can compare values
    if (!newState && !oldState) return true;
    if (!newState || !oldState) return false;
    if (typeof newState === 'object' || typeof oldState === 'object') {
        if (typeof newState !== 'object' || typeof oldState !== 'object') {
            return false;
        }

        const isArray = Array.isArray(newState);
        if (Object.keys(newState).length !== Object.keys(oldState).length) {
            return false;
        }

        return Object.keys(newState).reduce((bool, key) => {
            let newKey = isArray ? parseInt(key, 10) : key;
            return bool && deepCompare(newState[newKey], oldState[newKey], cumm);
        }, true);
    }

    // deals with audio url since url after '=' changes
    if (
        typeof newState === 'string' &&
        typeof oldState === 'string' &&
        (newState.includes('=') || oldState.includes('='))
    ) {
        newState = newState.slice(1, newState.indexOf('='));
        oldState = oldState.slice(1, oldState.indexOf('='));
    }
    return newState === oldState;
};

// https://remysharp.com/2010/07/21/throttling-function-calls
export function throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last, deferTimer;
    return function () {
        var context = scope || this;

        let now = +new Date();
        let args = arguments;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshhold);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
}

const url = require('url');

export const getFilePath = (urlString) => {
    try {
        const _url = url.parse(urlString);
        const pathSplits = _url.pathname.split('/');
        return decodeURI(pathSplits[pathSplits.length - 1]);
    } catch {
        return null;
    }
};

export const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    result.forEach((r, i) => (r.groupoffset = i));

    return result;
};

// Taken from https://blog.stevenlevithan.com/archives/javascript-roman-numeral-converter
export const romanize = (num) => {
    if (isNaN(num)) return NaN;
    let digits = String(+num).split(''),
        key = [
            '',
            'C',
            'CC',
            'CCC',
            'CD',
            'D',
            'DC',
            'DCC',
            'DCCC',
            'CM',
            '',
            'X',
            'XX',
            'XXX',
            'XL',
            'L',
            'LX',
            'LXX',
            'LXXX',
            'XC',
            '',
            'I',
            'II',
            'III',
            'IV',
            'V',
            'VI',
            'VII',
            'VIII',
            'IX'
        ],
        roman = '',
        i = 3;
    while (i--) roman = (key[+digits.pop() + i * 10] || '') + roman;
    return Array(+digits.join('') + 1).join('M') + roman;
};

export function getMonthName(month) {
    let words = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    return {
        name: words[month],
        number: month + 1
    };
}

// --- Publisher rename (T10) --------------------------------------------------
// Passport is the publisher's own portal, so it SUBSTITUTES: they see only their
// rebranded name, never "New (Old)" the way internal Gateway does.
//
// The canonical name is never replaced anywhere it is used as a value. tblTitle
// is filtered on `publisher`, the metadata Select submits `publisher`, and
// tblProvider.publishers is reconciled against it. Only labels change.

/** Label for a title row: the rebranded name if there is one, else canonical. */
export const publisherLabel = (title = {}) => {
    const display = title.publisher_display_name;
    if (typeof display === 'string' && display.trim()) return display.trim();
    return title.publisher;
};

/**
 * One option for a publisher dropdown.
 *
 * `value` is ALWAYS canonical -- it is what gets submitted and what the API
 * filters on. Only `label` carries the rebranded name.
 *
 * Accepts both shapes in play: `{name, display_name}` from
 * /authorized/vendor/<id>/publishers, and bare strings from
 * provider.publishers, which has no display name by design.
 */
export const publisherOption = (publisher) => {
    if (typeof publisher === 'string') return { label: publisher, value: publisher };
    if (!publisher || !publisher.name) return null;
    const display = publisher.display_name;
    const label = typeof display === 'string' && display.trim() ? display.trim() : publisher.name;
    return { label, value: publisher.name };
};

/** Canonical name out of either shape -- for anything sent back to the API. */
export const publisherValue = (publisher) => (typeof publisher === 'string' ? publisher : publisher && publisher.name);
